"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _default = function _default(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24.01",
    height: "24",
    viewBox: "0 0 24.01 24"
  }, props), /*#__PURE__*/_react["default"].createElement("polygon", {
    points: "14.29 6 11.06 9.22 15.2 12.5 18 9.71 14.29 6",
    fill: "#004864"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M23.81,20.61,10.15,9.77A5.68,5.68,0,0,1,8,12.16L20.66,23.87A.49.49,0,0,0,21,24c1.38,0,2.06,0,2.59-.77A3.75,3.75,0,0,0,24,21,.49.49,0,0,0,23.81,20.61Z",
    transform: "translate(0 0)",
    fill: "#004864"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M9.55,7.12A4,4,0,0,0,8,4.47,6.08,6.08,0,0,0,6.21,3.7C4.7,3.22,3.39,2.8,3.5.52A.52.52,0,0,0,3.21,0a.52.52,0,0,0-.56.1A6.89,6.89,0,0,0,1,7.89c.93,2.3,2.89,3.91,4.77,3.91a3.72,3.72,0,0,0,3-1.68A4,4,0,0,0,9.55,7.12Z",
    transform: "translate(0 0)",
    fill: "#004864"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M4,22.16,1.84,20l-.69.69a.48.48,0,0,0,0,.7l.4.4-1.4,1.4a.48.48,0,0,0,0,.7.48.48,0,0,0,.7,0l1.4-1.4.4.4a.48.48,0,0,0,.7,0Z",
    transform: "translate(0 0)",
    fill: "#004864"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M7.37,12.91,2.15,18.14a.5.5,0,0,0,0,.71l3,3a.48.48,0,0,0,.7,0l5.37-5.37Z",
    transform: "translate(0 0)",
    fill: "#004864"
  }), /*#__PURE__*/_react["default"].createElement("polygon", {
    points: "15.2 12.5 18 9.71 14.29 6 11.06 9.22 15.2 12.5",
    fill: "#004864"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M23.85,3.15l-3-3a.48.48,0,0,0-.7,0L15,5.29,18.71,9l3.72-3.72a1.72,1.72,0,0,1,.15.72,1.66,1.66,0,0,1-.43,1.15l-5,5a.48.48,0,0,0,0,.7h0a.48.48,0,0,0,.7,0l5-5A2.55,2.55,0,0,0,23.58,6a2.62,2.62,0,0,0-.41-1.46l.68-.69A.48.48,0,0,0,23.85,3.15Z",
    transform: "translate(0 0)",
    fill: "#004864"
  }));
};

exports["default"] = _default;